import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { useGlobalStore } from 'shared'

export const prefixPath = '/configurator/'


// 导出兼容vue2.7的router hooks
export * from 'vue-router/composables'

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history',
  // base: prefixPath,
})

router.beforeEach((to, from, next) => {
  console.log('router.beforeEach', to, from)
  
  if (from.name) {
    useGlobalStore().updateShowAllPage(to.name === 'overview')
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 车型兜底
  if (to.name === 'config' && !to.params.vehicle) {
    const modelFullPath = localStorage.getItem('model_fullPath')
    if (modelFullPath) {
      return location.href = location.origin + modelFullPath
    } else {
      return next({ path: to.path + '/ET7' })
    }
  }
  
  next()
})

export default router

// push跳转不能触发拦截，所以使用 location 跳转
export const goToLogin = redirect => location.href = '/login?redirect_to=' + (redirect || location.href)
